import * as React from "react";
import { cn } from "@/lib/utils";

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  error?: boolean;
}

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, error, children, ...props }, ref) => {
    return (
      <select
        ref={ref}
        aria-invalid={error || undefined}
        className={cn(
          "flex h-9 w-full cursor-pointer rounded-sm border border-input bg-card px-3 py-1 text-sm transition-[color,background-color,border-color,box-shadow] duration-150 ease-out hover:border-border-hover focus-visible:outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/30 disabled:cursor-not-allowed disabled:opacity-50",
          error &&
            "border-destructive hover:border-destructive focus-visible:border-destructive focus-visible:ring-destructive/25",
          className
        )}
        {...props}
      >
        {children}
      </select>
    );
  }
);
Select.displayName = "Select";
